import api from "@/utils/api";

export const state = {
  _balanceSchedule: null,
  _error: null,
};

export const mutations = {
  setBalanceSchedule(state, data) {
    state._balanceSchedule = data;
  },
  setError(state, error) {
    state._error = error;
  },
  resetBuyReport(state) {
    state._balanceSchedule = null;
    state._error = null;
  },
};

export const actions = {
  async acSaveBalanceSchedule({ commit, rootState }, params) {
    try {
      // 날짜 형식 변환: "YYYY-MM-DD" → "YYYYMMDD"
      const balanceDate = params.balance_date.replace(/-/g, "");

      // document URL 인코딩 (특수문자 +, =, / 등 처리)
      const encodedDocument = encodeURIComponent(params.document);
      const url = `/api/v1/report/${encodedDocument}/balance-date`;
      const requestBody = {
        balance_date: balanceDate,
      };

      const res = await api.patch(url, requestBody);

      if (res.data.code === 0) {
        commit("setBalanceSchedule", res.data.data);
        return { success: true };
      }

      return { success: false, message: "잔금일 저장에 실패했습니다." };
    } catch (error) {
      console.error("[buyReport] 잔금일 저장 실패:", error);
      commit("setError", error);

      // API 에러 응답 처리
      if (error.response && error.response.data) {
        return {
          success: false,
          message: error.response.data.message || "잔금일 저장 중 오류가 발생했습니다.",
        };
      }

      return { success: false, message: "잔금일 저장 중 오류가 발생했습니다." };
    }
  },

  /**
   * NZSC-3814: 초·중·하순(시기) 잔금일 저장.
   * balance_date와 동시 전송 금지(400 7507) — 시기 파라미터만 보낸다.
   * @param {string} params.document 리포트 document
   * @param {string} params.ym "YYYYMM"
   * @param {string} params.part "EARLY" | "MID" | "LATE"
   */
  async acSaveBalancePeriod({ commit }, params) {
    try {
      const encodedDocument = encodeURIComponent(params.document);
      const url = `/api/v1/report/${encodedDocument}/balance-date`;
      const requestBody = {
        balance_period_ym: params.ym,
        balance_period_part: params.part,
      };

      const res = await api.patch(url, requestBody);

      if (res.data.code === 0) {
        commit("setBalanceSchedule", res.data.data);
        return { success: true };
      }

      return { success: false, message: "잔금일 저장에 실패했습니다." };
    } catch (error) {
      console.error("[buyReport] 잔금일(시기) 저장 실패:", error);
      commit("setError", error);

      if (error.response && error.response.data) {
        return {
          success: false,
          message: error.response.data.message || "잔금일 저장 중 오류가 발생했습니다.",
        };
      }

      return { success: false, message: "잔금일 저장 중 오류가 발생했습니다." };
    }
  },

  async acGetBalanceSchedule({ commit }, orderSeq) {
    try {
      // TODO: 백엔드 API 구현 후 아래 주석 해제
      /*
      const url = `/api/v1/buy-report/balance-schedule/${orderSeq}`;
      const res = await api.get(url);

      if (res.data.code === 0) {
        commit("setBalanceSchedule", res.data.data);
        return res.data.data;
      }
      return null;
      */

      // 임시 코드
      console.log("[buyReport] 전금일 조회 요청:", orderSeq);
      return state._balanceSchedule;
    } catch (error) {
      console.error("[buyReport] 전금일 조회 실패:", error);
      commit("setError", error);
      return null;
    }
  },
};

export const getters = {
  balanceSchedule: state => state._balanceSchedule,
  buyReportError: state => state._error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
